import { NumberMaskProcessing } from './number';

export class PercentMaskProcessing extends NumberMaskProcessing {
  protected allowedDecimals = 0;
  protected min = 0;

  protected postProcess(): void {
    // add percent symbol to the right if missing
    const processed = this.processed;
    if (processed.value.length && processed.value.substr(processed.value.length - 1) !== '%') {
      processed.value += '%';
    }

    // rm symbol if there is no value
    if (processed.value === '%') {
      processed.value = '';
      processed.selection[0] = processed.selection[1] = 0;
    }

    // move cursor left to the percent symbol if it's not a selection
    if (processed.selection[0] === processed.selection[1] && processed.selection[0] >= processed.value.length) {
      processed.selection[0] = processed.selection[1] = processed.value.length - 1;
    }
  }
}
